import React, { FC } from 'react';
import AgentApplicationTable from '~/pages/agent/components/agent/AgentApplicationTable';

const Applications: FC = () => {
  return <AgentApplicationTable />;
};

export default Applications;
